import {Log} from '@aboutyou/mlm/';
import React, {useCallback} from 'react';
import styled from 'styled-components';
import {SHARE_USER_SESSION_EVENT, SYNC_SESSION_ROUTE} from './constants';

interface Props {
  alternateLangUrl: string | undefined;
  sessionData: Record<
    string,
    {
      key: string;
      data: unknown;
    }
  >;
}
/**
 * This Components enables sharing user session between the current domain and target domain of the following shops
 * using iframe post and receive messages mechanism
 * DE <=> EN_DE
 * CH <=> FR_CH
 * BE <=> FR_BE
 */
export const ShareUserSession: React.FC<Props> = props => {
  const {sessionData, alternateLangUrl} = props;
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  const [isTargetIframeLoaded, setIsTargetIframeLoaded] = React.useState(false);

  React.useEffect(() => {
    if (isTargetIframeLoaded && alternateLangUrl) {
      // The target domain receives message from parent domain
      // For instance de_EN <=> en_DE | fr_CH <=> de_CH
      // Send the legacy user data from the parent domain to the child domain
      iframeRef.current?.contentWindow?.postMessage(
        {
          event: SHARE_USER_SESSION_EVENT,
          sessionData,
        },
        alternateLangUrl,
      );
    }
  }, [isTargetIframeLoaded, alternateLangUrl, sessionData]);

  const onError = useCallback(
    (error: any) => {
      Log.error(
        '@aboutyou/logic-components',
        `Failed to load alternate lang iframe with url ${alternateLangUrl}`,
        {error},
      );
    },
    [alternateLangUrl],
  );

  if (!alternateLangUrl) {
    return null;
  }

  const iframeUrl = `${alternateLangUrl}${SYNC_SESSION_ROUTE}`;

  return (
    <HiddenIframe
      data-testid="alternate-lang-iframe"
      ref={iframeRef}
      onError={onError}
      onLoad={() => setIsTargetIframeLoaded(true)}
      src={iframeUrl}
    />
  );
};

const HiddenIframe = styled.iframe`
  height: 0;
  width: 0;
  overflow: hidden;
  position: absolute;
  display: none;
`;
